import { useState } from "react";
import { useNavigate } from "react-router-dom";

// internal hooks
import { useEscape } from "../../hooks/useEscape";
import useGetFetchFromId from "../../hooks/useGetFetchFromId";
import { useVerifyUnique } from "../../hooks/useVerifyUnique";

// components
import DropDown from "../../formComponents/DropDown";
import FormButton from "../../formComponents/FormButton";

// styles and images
import Close from "../../assets/close.svg";
import "../companies/AddCompany.css";

// store
import {
  userStore,
  messageAndErrorStore,
  adminDataStore,
  triggersStore,
} from "../../store/Store";
import InlineInput from "../../formComponents/InlineInput";

export default function AddEditAdminCompany(props) {
  // global state
  const currentUser = userStore((data) => data.currentUser);
  const JwtToken = userStore((data) => data.JwtToken);
  const setAuthError = messageAndErrorStore((data) => data.setAuthError);
  const toggleNewMessage = messageAndErrorStore(data => data.toggleNewMessage)
  const setAdminCompanyData = adminDataStore(
    (data) => data.setAdminCompanyData,
  );
  const setAdminCompanyTrigger = triggersStore(
    (data) => data.setAdminCompanyTrigger,
  );

  // state
  let id = 0;
  if (props.id) {
    id = props.id;
  }
  const [oldName, setOldName] = useState("");
  const [formError, setFormError] = useState(null);
  const [isPending, setIsPending] = useState(false);
  const [company, setCompany] = useState({
    id,
    company_name: "",
    created_by_id: currentUser.id,
    updated_by_id: currentUser.id,
    company_type_id: 0,
    pc_carrier_id: "",
  });

  const companyOptions = [
    { value: 1, label: "Tenant" },
    { value: 2, label: "Carrier" },
  ];
  const navigate = useNavigate();

  const { exists } = useVerifyUnique(
    props.coDocs,
    "company_name",
    company.company_name,
    oldName,
  );

  const { error } = useGetFetchFromId(
    `${process.env.REACT_APP_BACKEND}/admin/companies/${id}`,
    setCompany,
    id,
    setOldName,
    "company_name",
  );

  const handleClose = () => {
    setAdminCompanyTrigger(false);
    props.setDocId("");
  };
  useEscape(setAdminCompanyTrigger, [props.setDocId], [""], isPending);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCompany({
      ...company,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsPending(true);
    if (exists) {
      setFormError("Company Already Exists");
      setIsPending(false);
      return;
    }
    let method = "POST";
    if (id > 0) {
      method = "PATCH";
    }
    const controller = new AbortController();
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", "Bearer " + JwtToken);
    const requestOptions = {
      method: method,
      headers: headers,
      body: JSON.stringify(company),
      signal: controller.signal,
    };

    fetch(
      `${process.env.REACT_APP_BACKEND}/admin/company/${company.id}`,
      requestOptions,
    )
      .then((res) => {
        if (!res.ok) {
          if (res.status === 401) {
            setAuthError(false);
            setCompany(false);
            setIsPending(false);
            navigate("/login");
          } else {
            toggleNewMessage(`Something Went Wrong Status: ${res.status}`);
            return Promise.resolve();
          }
        } else {
          return res.json();
        }
      })
      .then((data) => {
        if (!data) {
          setIsPending(false);
        } else {
          setAdminCompanyTrigger(false);
          setIsPending(false);
          setAdminCompanyData(data);
          toggleNewMessage(null, "Success");
        }
      })
      .catch((err) => {
        toggleNewMessage("Something Went Wrong");
        setIsPending(false);
        return;
      })
      .finally(() => setIsPending(false));
    return () => controller.abort();
  };

  return (
    <div className="popup">
      <div className="popup-inner-add-company">
        <h3>Add Admin Company</h3>
        <br />
        {!isPending && <img src={Close} onClick={handleClose} alt="close" />}
        <form onSubmit={handleSubmit}>
          <DropDown
            classOne="row mb-3"
            classTwo="col-form-label bold-label col-sm-3"
            title="Company Type"
            name="company_type_id"
            options={companyOptions}
            onChange={(o) =>
              setCompany({ ...company, company_type_id: o.value })
            }
            required={true}
            value={companyOptions.filter(
              (x) => x.value === company.company_type_id,
            )}
            placeholder="Select Company Type"
          />
          {company.company_type_id !== 0 && (
            <InlineInput
              title={"Company Name"}
              className={"form-control"}
              type={"text"}
              name={"company_name"}
              value={company.company_name}
              onChange={handleChange}
              placeholder={"Enter Company Name"}
              required={true}
            />
          )}
          {company.company_type_id === 2 && (
            <InlineInput
              title={"PC Carrier ID"}
              className={"form-control"}
              type={"text"}
              name={"pc_carrier_id"}
              value={company.pc_carrier_id}
              onChange={handleChange}
              placeholder={"Enter PC Carrier ID"}
              required={true}
            />
          )}
          <FormButton pending={isPending} name={"Submit"} />
        </form>
        {(formError || error) && (
          <p className="error">{"Somehting Went Wrong"}</p>
        )}
      </div>
    </div>
  );
}
